export enum PROGRAM_PORTFOLIO_MODULE_FLAGS {
  REQUIRED = 'REQUIRED',
  NOT_REQUIRED = 'NOT_REQUIRED'
}
